import React from 'react'
import SeatList from './SeatList'
const IndexSeats = () => {
  return (
    <div style={{ fontFamily: 'Lato, sans-serif' }}>
      
      <SeatList/>
    </div>
  )
}

export default IndexSeats
